import {type Ref} from "react";

import {FieldWrapper, IFieldWrapperProps} from "../../atoms/wrapper/FieldWrapper";
import {getFieldState} from "../../field_state_helper";
import {getErrorMessage} from "../../utils/get_error_message";
import {ITextAreaProps, Textarea} from "./TextArea";

export type ITextareaFieldProps = (IFieldWrapperProps & ITextAreaProps) & {
    ref?: Ref<HTMLTextAreaElement | null>;
};

export function TextareaField(props: ITextareaFieldProps) {
    const {ref, labelContent, message, id, className, error, dataTestId, ...textAreaProps} = props;

    const fieldState = getFieldState(props);
    const errorMessage = getErrorMessage(error);

    return (
        <FieldWrapper
            labelContent={labelContent}
            fieldState={fieldState}
            message={errorMessage || message}
            htmlFor={id}
            className={className}
            dataTestId={dataTestId}
        >
            <Textarea {...textAreaProps} ref={ref} id={id} fieldState={fieldState} />
        </FieldWrapper>
    );
}
import {type Ref} from "react";

import {FieldWrapper, IFieldWrapperProps} from "../../atoms/wrapper/FieldWrapper";
import {getFieldState} from "../../field_state_helper";
import {getErrorMessage} from "../../utils/get_error_message";
import {ITextAreaProps, Textarea} from "./TextArea";

export type ITextareaFieldProps = (IFieldWrapperProps & ITextAreaProps) & {
    ref?: Ref<HTMLTextAreaElement | null>;
};

export function TextareaField(props: ITextareaFieldProps) {
    const {ref, labelContent, message, id, className, error, dataTestId, ...textAreaProps} = props;

    const fieldState = getFieldState(props);
    const errorMessage = getErrorMessage(error);

    return (
        <FieldWrapper
            labelContent={labelContent}
            fieldState={fieldState}
            message={errorMessage || message}
            htmlFor={id}
            className={className}
            dataTestId={dataTestId}
        >
            <Textarea {...textAreaProps} ref={ref} id={id} fieldState={fieldState} />
        </FieldWrapper>
    );
}
